import { Injectable } from '@angular/core';
import { EntryMainWorkflowStatusDto } from '@osos/shared/api';
import {
  DataEntryWorkflowStatusPresenterModel,
  Step,
} from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class EntryWorkFlowStatusParserV1Service extends ParserBase<
  EntryMainWorkflowStatusDto,
  DataEntryWorkflowStatusPresenterModel
> {
  constructor() {
    super(EntryMainWorkflowStatusDto, DataEntryWorkflowStatusPresenterModel, 1);
  }

  getPresenterModel(
    model: EntryMainWorkflowStatusDto,
  ): DataEntryWorkflowStatusPresenterModel {
    // Recursively map the workflow steps to handle sub-workflows
    const steps: Step[] = (model.steps || []).map((apiStep) =>
      this._mapApiStepToPresenterStep(apiStep),
    );

    return {
      workflowId: model.workflowId,
      isMainFlowDetermined: model.isMainFlowDetermined,
      steps,
    } as DataEntryWorkflowStatusPresenterModel;
  }

  /**
   * Recursively maps API step to presenter Step
   * Handles nested sub-workflow steps
   */
  private _mapApiStepToPresenterStep(apiStep: any): Step {
    // Recursively map nested sub-workflow steps
    const subWorkflowSteps: Step[] | undefined =
      apiStep.subWorkflowSteps && apiStep.subWorkflowSteps.length > 0
        ? apiStep.subWorkflowSteps.map((nestedStep: any) =>
            this._mapApiStepToPresenterStep(nestedStep),
          )
        : undefined;

    return {
      id: apiStep.id || '',
      type: (apiStep.type as any) || 0,
      actions: apiStep.actions || [],
      mainFlowIndex: apiStep.mainFlowIndex || 0,
      name: apiStep.name || { en: '', ar: '' },
      description: apiStep.description || { en: '', ar: '' },
      notes: apiStep.notes || '',
      executedBy: apiStep.executedBy || [],
      owner: apiStep.owner || undefined,
      originalOwner: apiStep.originalOwner || undefined,
      recievedAt: apiStep.recievedAt,
      executedAt: apiStep.executedAt,
      executors: apiStep.executors || [],
      originalOwnerUsers: apiStep.originalOwnerUsers,
      stepOwnerSelectionCriteria: apiStep.stepOwnerSelectionCriteria as any,
      subWorkflowId: apiStep.subWorkflowId,
      subWorkflowInstanceId: apiStep.subWorkflowInstanceId,
      subWorkflowSteps,
      instanceId: apiStep.instanceId,
      isAdhoc: apiStep.isAdhoc,
      parentStepId: apiStep.parentStepId,
      skippedBy: apiStep.skippedBy,
    } as Step;
  }

  getDataModel(
    presenter: DataEntryWorkflowStatusPresenterModel,
  ): EntryMainWorkflowStatusDto {
    const model = {
      workflowId: presenter.workflowId,
      isMainFlowDetermined: presenter.isMainFlowDetermined,
      steps: presenter.steps,
    } as EntryMainWorkflowStatusDto;

    return model;
  }
}
